var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSplashLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 48,
    viewBox: "0 0 29 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.2961 38.9398C11.5903 41.0503 11.8827 44.2586 13.9487 46.1051C16.0149 47.9518 19.0727 47.738 20.7785 45.6275C23.8671 41.806 24.7588 32.7299 24.7588 32.7299C24.7588 32.7299 16.3847 35.1183 13.2961 38.9398Z",
    fill: "#2A7DFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M13.2961 9.50946C11.5903 7.39893 11.8827 4.19066 13.9487 2.34412C16.0149 0.497381 19.0727 0.711233 20.7785 2.82176C23.8671 6.64325 24.7588 15.7193 24.7588 15.7193C24.7588 15.7193 16.3847 13.331 13.2961 9.50946Z",
    fill: "#2A7DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M8.27189 19.0628C5.63701 19.0628 3.50096 21.374 3.50096 24.2243C3.50096 27.0748 5.63701 29.3857 8.27189 29.3857C13.0428 29.3857 20.1992 24.2243 20.1992 24.2243C20.1992 24.2243 13.0428 19.0628 8.27189 19.0628Z",
    fill: "#2A7DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplashLeft);
export default __webpack_public_path__ + "static/media/splashLeft.4a076663820363a761706b4f1d489eb6.svg";
export { ForwardRef as ReactComponent };